export default __webpack_public_path__ + "static/media/woman.cddee4d9.svg";